module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_19.d9dff935.png";